<div class="empty-state">
  <div class="empty-card" role="status" aria-live="polite">
    <div class="empty-top">
      <div class="empty-icon" aria-hidden="true">
        <app-icon [name]="iconName" size="custom" customSize="28px" color="on-primary-container"></app-icon>
      </div>

      <div class="empty-text">
        <div class="empty-title" tabindex="0">{{ title }}</div>
        <div class="empty-subtitle" tabindex="0">{{ subtitle }}</div>
      </div>
    </div>

    <div class="empty-divider"></div>

    <div class="empty-hint" tabindex="0">{{ hint }}</div>

    <!-- Outside the role="status" copy above would be wrong (it is inside the card), but the button
         carries its own accessible name, so the live region announcing it alongside the copy is what
         we want: the patient hears the way out at the same time as the reason there is nothing here. -->
    @if (actionLabel) {
      <div class="empty-actions">
        <button
          mat-flat-button
          type="button"
          class="primary-btn"
          data-testid="empty-state-action"
          (click)="action.emit()">
          <app-icon [name]="actionIcon" size="sm" color="on-primary" aria-hidden="true"></app-icon>
          {{ actionLabel }}
        </button>
      </div>
    }
  </div>
</div>
